import { all, call } from "typed-redux-saga/macro";
import { homeSagas } from "./home/home.sagas";
import { authSagas } from "./auth/auth.sagas";

export function* rootSaga() {
    yield* all([call(homeSagas), call(authSagas)]);
}
